__turbopack_context__.v({
  "embla-carousel": "EmblaCarousel-module-scss-module__Junrja__embla-carousel",
  "embla-carousel__container": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__container",
  "embla-carousel__embla": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__embla",
  "embla-carousel__empty": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__empty",
  "embla-carousel__nav-button": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__nav-button",
  "embla-carousel__nav-button--next": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__nav-button--next",
  "embla-carousel__nav-button--prev": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__nav-button--prev",
  "embla-carousel__nav-icon": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__nav-icon",
  "embla-carousel__nav-icon--next": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__nav-icon--next",
  "embla-carousel__nav-icon--prev": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__nav-icon--prev",
  "embla-carousel__slide": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__slide",
  "embla-carousel__title": "EmblaCarousel-module-scss-module__Junrja__embla-carousel__title",
});
